import { ConfirmModal } from '@affine/component/ui/modal';
import { useI18n } from '@affine/i18n';

import * as styles from './member-limit-modal.css';

// yoDEV (YOD-620): there is a single plan, so hitting the member limit is a
// plain fact, not an upsell. No "Upgrade" button, no plan link, no Team
// Workspace pitch — the modal only explains the limit and closes.
export interface MemberLimitModalProps {
  open: boolean;
  quota: string;
  setOpen: (value: boolean) => void;
}

export const MemberLimitModal = ({
  open,
  quota,
  setOpen,
}: MemberLimitModalProps) => {
  const t = useI18n();

  return (
    <ConfirmModal
      open={open}
      onOpenChange={setOpen}
      title={t['com.affine.payment.member-limit.title']()}
      description={<ConfirmDescription quota={quota} />}
      confirmText={t['com.affine.payment.member-limit.pro.confirm']()}
      confirmButtonOptions={{
        variant: 'primary',
      }}
      cancelButtonOptions={{
        style: { visibility: 'hidden' },
      }}
      onConfirm={() => setOpen(false)}
    ></ConfirmModal>
  );
};

export const ConfirmDescription = ({ quota }: { quota: string }) => {
  const t = useI18n();
  return (
    <div>
      {t['com.affine.payment.member-limit.description']({
        quota: quota,
      })}
      <ul className={styles.ulStyle}>
        <li className={styles.liStyle}>
          <div className={styles.prefixDot} />
          {t[
            'com.affine.payment.member-limit.description.tips-for-free-plan'
          ]()}
        </li>
        <li className={styles.liStyle}>
          <div className={styles.prefixDot} />
          {t['com.affine.payment.member-limit.description.tips-2']()}
        </li>
      </ul>
    </div>
  );
};
